// src/store/services/ImpactoStocks.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../feathers-client'

class ImpactoStock extends BaseModel { }
ImpactoStock.modelName = "ImpactoStock"
ImpactoStock.instanceDefaults = () => {
  return {}
}
const servicePath = 'impacto-stock'
const servicePlugin = makeServicePlugin({
  Model: ImpactoStock,
  service: feathersClient.service(servicePath),
  servicePath
})

export default servicePlugin
